import classcat from "classcat";
import React, { useCallback } from "react";

import { Image } from "@is/components/Image";
import { MediaVariants } from "@is/constants";
import { TrackingEventTypes, trackEvent } from "@is/services/EventTracking";
import { EventData } from "@is/services/EventTracking/EventTracking.types";
import { MediaType } from "@is/types";

import css from "./ProductMedia.module.css";

const highlightedItem = 3;

type Props = {
  media: MediaType;
  large?: boolean;
  disableZoom?: boolean;
  contentItemIndex: number;
  index: number;
  loadedItemIndex?: number;
  animated?: boolean;
  onSetMedias?: (index: number) => void;
  onDrawersClose: () => void;
  eventData?: EventData;
};

const ProductMedia = ({
  media,
  large,
  disableZoom,
  contentItemIndex,
  index,
  loadedItemIndex,
  animated,
  onSetMedias,
  onDrawersClose,
  eventData,
}: Props) => {
  const handleClick = useCallback(() => {
    if (disableZoom) {
      return;
    }

    onSetMedias(index);
    onDrawersClose();

    trackEvent({
      eventType: TrackingEventTypes.TapToEnlargeMedia,
      data: eventData,
    });
  }, [onSetMedias, onDrawersClose, disableZoom, index, eventData]);

  return (
    <div
      style={{ ["--loaded-item-index" as string]: loadedItemIndex || 0 }}
      className={classcat([
        { [css.animatedWrapper]: animated },
        { [css.highlighted]: index === contentItemIndex % highlightedItem },
      ])}
    >
      <div
        className={classcat([css.container, { [css.active]: large }])}
        onClick={handleClick}
      >
        <Image
          style={{ overflowClipMargin: "unset" }}
          mediavariant={MediaVariants.LARGE}
          placeholderMediaVariant={MediaVariants.MEDIUM}
          src={media.url}
          layout="cover"
        />
      </div>
    </div>
  );
};

export default ProductMedia;
